<template>
    <div>
        <div class="jobFunction"  :class="active" >
            <div class="jobFunction-contian" v-on:click="select($store.getters.getContent(jobFunction.title))">
                <span class="" :class="{'flat-left':$store.state.innerWidth>768}">
                    <img class="iconImage" v-bind:src="icon" />
                </span>
                <span class="jobGroup mainColor jobGroupText SemiBold">
                    <a href="javascript:;" style="color: inherit">{{$store.getters.getContent(jobFunction.title)}}</a>
                </span>
                <i class="icon-add mainColor" ></i>
                <!-- <i class="icon-close " v-if="isOpen"></i> -->
            </div>
            <VueSlideToggle v-if="!isIos" :open="showList" tag="section" :duration="500">
                <Occupations v-if="isOpen" :callback="showSlide" v-bind:childLogGaEvent="childLogGaEvent" v-bind:jobFunctionCode="jobFunction.jobFunctionCode" v-bind:jobFunctionId="jobFunction.id" class="occupations"  ></Occupations>
            </VueSlideToggle>
            <div v-if="isIos" v-show="showList" tag="section" :duration="500">
                <Occupations v-if="isOpen" :callback="showSlide" v-bind:childLogGaEvent="childLogGaEvent" v-bind:jobFunctionCode="jobFunction.jobFunctionCode" v-bind:jobFunctionId="jobFunction.id" class="occupations"  ></Occupations>
            </div>
        </div>
    </div>
</template>
<script>
import Occupations from '@/components/Occupations'
import { VueSlideToggle } from 'vue-slide-toggle'
export default {
    components: {
       Occupations,
       VueSlideToggle
    },
    data() {
        return {
            isOpen: false,
            active:"",
            icon:"",
            showList:false,
            isIos:false
        }
    }, 
    props: [
        'jobFunction',
        'childLogGaEvent',
        'index'

    ],
     activated(){
    
        if(this.$store.state.formData.headTabState2){
            this.showList = false;
            this.isOpen = false;

            this.active = "";
            this.$store.state.selectMenu = 2;
        }
    },
    methods: {
        showSlide:function(){
            let that =this
            this.showList = true;
            setTimeout(function() {
                that.active=that.showList?'active':''
            });
        },
        checkIosEvent:function(){
            return /iPhone|iPad|iPod/i.test(navigator.userAgent);
        }
    },
    mounted() {
        // 
        this.isIos = this.checkIosEvent()
        var icon
        icon = require('@/images/flat_icon/'+this.jobFunction.jobFunctionCode+'.png');
        var that = this;
        this.$set(this,'icon',icon)
        this.select = function(title) {
            this.childLogGaEvent('userClick','jobFunction',title);
            if(!this.isOpen){
                this.isOpen = true;
            }else{
                this.showList = !this.showList;
                setTimeout(function() {
                    that.active=that.showList?'active':''
                });
            }
        }
    }
}
</script>